module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Wood.4cc5b6d1.jpg";